const companyInitialQuestions = [
    {Question: 'Area of work of company', Answer: ''},
    {Question: 'Which Module/Business Process you wish to Develop? (ex. HR or Procurement)', Answer: ''},
    {Question: 'What are the main challenges you are trying to solve with this Module?', Answer: ''},
]
export default companyInitialQuestions